module.exports = __webpack_public_path__ + "img/tpc-41.826bd412.jpg";